export default __webpack_public_path__ + "static/media/IM2.7cb3c5bb.png";